import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { RouteKeys } from 'src/app/share/helper/route-keys.helper';
import { ApiService } from 'src/app/share/services/api.service';
import { AuthService } from 'src/app/share/services/auth.service';
import { LanguageService } from 'src/app/share/services/language.service';
import { StorageService } from 'src/app/share/services/storage.service';
import { UrlService } from 'src/app/share/services/url.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  @ViewChild('loginForm', { static: false }) loginForm: DxFormComponent;

  loading: boolean = false;
  error: string = '';
  returnUrl: string;
  emailVerified: boolean = true;

  loginFormData: any = {
    username: '',
    password: '',
    confirm: false,
  };

  constructor(
    private storageService: StorageService,
    private urlService: UrlService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private languageService: LanguageService,
    private apiService: ApiService
  ) {
    this.onUsernameEnterKey = this.onUsernameEnterKey.bind(this);
  }

  ngOnInit(): void {
    this.storageService.clearSession();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || null;
  }

  onSubmit = () => {
    if (this.loading) {
      return;
    }
    this.error = '';

    const validationFromResult = this.loginForm.instance.validate();
    if (validationFromResult.isValid) {
      this.loading = true;
      this.authService.login(
        this.loginFormData.username,
        this.loginFormData.password,
        () => {
          const Rolles = this.authService.getRoles();

          if (Rolles.length > 0 && Rolles[0] === 1) {
            // 1 für Bürger
            if (this.returnUrl !== undefined && this.returnUrl !== null && this.returnUrl.length > 0) {
              this.urlService.naviToMergeQueryParams(this.returnUrl, { returnUrl: null }).then(() => {
                this.loading = false;
              });
            } else {
              this.urlService.naviToPreserveQueryParams('intern').then(() => {
                this.loading = false;
              });
            }
          } else {
            this.loading = false;
            this.error = this.languageService.translate('loginError');
          }
        },
        (err) => {
          this.loading = false;
          if (err.status === 403) {
            this.error = this.languageService.translate('loginError');
          } else if (err.status === 423) {
            this.emailVerified = false;
            this.error = this.languageService.translate('verifyError');
          } else {
            this.error = this.languageService.translate('serverError');
            throw err;
          }
        }
      );
    }
  };

  onContentReady(e) {
    e.component.getEditor('username').focus();
  }

  onUsernameEnterKey(e) {
    this.loginForm.instance.getEditor('password').focus();
  }

  onVerifySend() {
    if (this.loginFormData.username != '') {
      this.loading = true;
      this.apiService.post(RouteKeys.Extern.Register.send_verify_email, { email: this.loginFormData.username }).subscribe({
        next: (response) => {
          this.emailVerified = false;
          this.error = this.languageService.translate('sendVerify');
          this.emailVerified = true;
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.emailVerified = false;
          this.error = err?.error?.message || err?.error?.Message || this.languageService.translate('laterError');
        },
      });
    }
  }
}
